import { DateTime } from 'luxon';
import { defineStore } from 'pinia';

export type UserCredentials = {
	accessToken: string;
	expiresAt: DateTime;
};

type AuthState = {
	credentials: UserCredentials | null;
	shouldShowInvalidAccessTokenModal: boolean;
};

export const useAuthStore = defineStore('auth', {
	state: (): AuthState => {
		return {
			credentials: null,
			shouldShowInvalidAccessTokenModal: false,
		};
	},

	getters: {
		isUserSignedIn: function (state: AuthState): boolean {
			return state.credentials != null;
		},
		isAccessTokenValid: function (state: AuthState): boolean {
			if (this.isUserSignedIn) {
				const currentTime = DateTime.now();
				return currentTime < state.credentials!.expiresAt;
			} else {
				return false;
			}
		},
	},

	actions: {
		updateCredentials: function (credentials: UserCredentials | null) {
			this.credentials = credentials;
		},
		showInvalidAccessTokenModal: function () {
			this.shouldShowInvalidAccessTokenModal = true;
		},
		hideInvalidAccessTokenModal: function () {
			this.shouldShowInvalidAccessTokenModal = false;
		},
	},
});
